
<section class="container-fluid sts-section">

  <app-sts-section-header *ngIf="channel=='email'" key="sts-signup-step-3-validate-header" [errors]="errors">
    Validate Your Email
    <app-sts-section-header-side>
      <div class="text-right"><a
        routerLink="/account/help" app-sts-cms-txt key="sts-need-help">Need help?</a>
      </div>
    </app-sts-section-header-side>
  </app-sts-section-header>

  <app-sts-section-header *ngIf="channel=='phone'" key="sts-signup-step-3-validate-header-phone" [errors]="errors">
    Validate Your Phone
    <app-sts-section-header-side>
      <div class="text-right"><a routerLink="/account/help" app-sts-cms-txt key="sts-need-help">Need help?</a>
      </div>
    </app-sts-section-header-side>
  </app-sts-section-header>

  <div class="sts-body row" *ngIf="hasBeenSent && channel=='email'">
    <div class="col-24">
      <div>
        {{sentEmailMessage}}
      </div>
    </div>
  </div>
  <div class="sts-body row" *ngIf="hasBeenSent && channel=='phone'">
    <div class="col-24">
      <div>
        {{sentPhoneTextMessage}}
      </div>
    </div>
  </div> 


  <form #form="ngForm"
        (ngSubmit)="onSubmitCode()"
        [formGroup]="frm2"
        class="sts-form" autocomplete="off">

    <div class="row sts-form-row">
      <div class="col-24">

        <!-- -->
        <div class="sts-object">

          <div>
            <label app-sts-cms-txt key="sts-pick-verification-code" for="sts_verification_code">
              Verification Code:
            </label>
            <input type="text"
                   id="sts_verification_code"
                   name="sts_verification_code"
                   formControlName="code"
                   maxlength="100"
                   [ngClass]="{'has-errors' : isInvalidCode() }"
                   class="sts-textbox" >
            <div class="text-danger" *ngIf="frm2.controls['code'].invalid && (frm2.controls['code'].dirty || frm2.controls['code'].touched)">
              <div app-sts-cms-txt key="sts-email-is-valid-required" *ngIf="frm2.controls['code'].errors['required']">A valid code is required</div>
            </div>
            <div class="sts-form-row sts-form-last-row">
              <div class="sts-form-row">
                <input type="checkbox" name="trust" id="trust_device" value="trust" formControlName="trust" />
                <label app-sts-cms-txt key="sts-trust-two-fa-device-label" for="trust_device" >
                  Trust this device for future logins.
                </label>
              </div>
              <a *ngIf="channel=='email'" href="javascript:void(0)" (click)="resendEmail()" app-sts-cms-txt key="sts-resend-email-2fa-cta">(resend email)</a>
              <a *ngIf="channel=='phone'" href="javascript:void(0)" (click)="resendEmail()" app-sts-cms-txt key="sts-resend-email-2fa-cta-phone">(resend SMS)</a>
            </div>

          </div>


        </div>
        <!-- -->


      </div>
    </div>

    <div class="row">
      <div class="col-24">

        <!-- -->
        <div class="sts-object">
          <button app-sts-cms-txt key="sts-cancel-button"
                  class="sts-btn other-sts-btn"
                  type="button"
                  (click)="gotoHome()">
            Cancel
          </button>

          <app-sts-button [submit]="submitter"  [disabled]="isRunOfAttempt"
                          key="sts-next-button">
            Next
          </app-sts-button>
        </div>
        <!-- -->

      </div>
    </div>

  </form>


</section>


